export const VARIANT_CHECK_NOTIFICATION_MESSAGES = {
  VARIANT_CREATION_STARTED: 'Variant creation started',
  VARIANT_CREATION_STARTED_DESCRIPTION:
    'Metadata retrieval and variant creation are running in the background. You can continue working.',
} as const;
